function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { readInheritableStaticObjectPairs } from "./inheritable_statics";
import { camelize, capitalize, dasherize } from "./string_helpers";
/** @hidden */
export function ValuePropertiesBlessing(constructor) {
  var valueDefinitionPairs = readInheritableStaticObjectPairs(constructor, "values");
  var propertyDescriptorMap = {
    valueDescriptorMap: {
      get: function get() {
        var _this = this;
        return valueDefinitionPairs.reduce(function (result, valueDefinitionPair) {
          var _a;
          var valueDescriptor = parseValueDefinitionPair(valueDefinitionPair);
          var attributeName = _this.data.getAttributeNameForKey(valueDescriptor.key);
          return Object.assign(result, (_a = {}, _a[attributeName] = valueDescriptor, _a));
        }, {});
      }
    }
  };
  return valueDefinitionPairs.reduce(function (properties, valueDefinitionPair) {
    return Object.assign(properties, propertiesForValueDefinitionPair(valueDefinitionPair));
  }, propertyDescriptorMap);
}
/** @hidden */
export function propertiesForValueDefinitionPair(valueDefinitionPair) {
  var _a;
  var definition = parseValueDefinitionPair(valueDefinitionPair);
  var type = definition.type,
    key = definition.key,
    name = definition.name;
  var read = readers[type],
    write = writers[type] || writers.default;
  return _a = {}, _a[name] = {
    get: function get() {
      var value = this.data.get(key);
      if (value !== null) {
        return read(value);
      } else {
        return definition.defaultValue;
      }
    },
    set: function set(value) {
      if (value === undefined) {
        this.data.delete(key);
      } else {
        this.data.set(key, write(value));
      }
    }
  }, _a["has" + capitalize(name)] = {
    get: function get() {
      return this.data.has(key);
    }
  }, _a;
}
function parseValueDefinitionPair(_a) {
  var token = _a[0],
    typeConstant = _a[1];
  var type = parseValueTypeConstant(typeConstant);
  return valueDescriptorForTokenAndType(token, type);
}
function parseValueTypeConstant(typeConstant) {
  switch (typeConstant) {
    case Array:
      return "array";
    case Boolean:
      return "boolean";
    case Number:
      return "number";
    case Object:
      return "object";
    case String:
      return "string";
  }
  throw new Error("Unknown value type constant \"" + typeConstant + "\"");
}
function valueDescriptorForTokenAndType(token, type) {
  var key = dasherize(token) + "-value";
  return {
    type: type,
    key: key,
    name: camelize(key),
    get defaultValue() {
      return defaultValuesByType[type];
    }
  };
}
var defaultValuesByType = {
  get array() {
    return [];
  },
  boolean: false,
  number: 0,
  get object() {
    return {};
  },
  string: ""
};
var readers = {
  array: function array(value) {
    var array = JSON.parse(value);
    if (!Array.isArray(array)) {
      throw new TypeError("Expected array");
    }
    return array;
  },
  boolean: function boolean(value) {
    return !(value == "0" || value == "false");
  },
  number: function number(value) {
    return parseFloat(value);
  },
  object: function object(value) {
    var object = JSON.parse(value);
    if (object === null || _typeof(object) != "object" || Array.isArray(object)) {
      throw new TypeError("Expected object");
    }
    return object;
  },
  string: function string(value) {
    return value;
  }
};
var writers = {
  default: writeString,
  array: writeJSON,
  object: writeJSON
};
function writeJSON(value) {
  return JSON.stringify(value);
}
function writeString(value) {
  return "" + value;
}